<template>
    <div v-if="showMessage" class="switch-theme-message">
        <div>
            <span>
                Are you not satisfied with the {{ themeSelected }} theme? Switch to the
                <span class="switch-theme" @click="toggleTheme()"
                    >{{ themeSelected == "dark" ? "light" : "dark" }} theme</span
                >. The theme can also be changed later on the Personal Info page.
            </span>
        </div>
        <span @click="hideMessage()" class="close-button">&times;</span>
    </div>
</template>

<script>
import { switchTheme } from "@/helpers/data";
import { getItem } from "@/store/persistantStorage";

export default {
    name: "SwitchThemeMessage",
    data() {
        const { isPerformax } = require("@/helpers/variant");
        return {
            showMessage:
                !isPerformax &&
                (localStorage.getItem("showSwitchThemeMessage") === "true" ||
                    localStorage.getItem("showSwitchThemeMessage") === null),
            themeSelected: getItem("theme") || "",
        };
    },
    methods: {
        toggleTheme() {
            switchTheme();
            this.themeSelected = getItem("theme");
        },
        hideMessage() {
            this.showMessage = false;
            localStorage.setItem("showSwitchThemeMessage", "false");
        },
    },
};
</script>

<style lang="scss" scoped>
.switch-theme-message {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row reverse;
    margin: 1.5rem 0.5rem 0;
    @include --mobile-viewport {
        margin-left: 0;
        margin-right: 0;
    }
    color: white;
    border-radius: 4px;
    padding: 0.5rem 1rem;
    font-size: 0.9rem;
    background-color: $transparent-green;

    &__content {
        padding: 0 1rem;
    }
    &__header {
        font-weight: bold;
    }
}
.close-button {
    font-size: 2rem;
    border: none;
    display: inline-block;
    vertical-align: middle;
    text-decoration: none;
    color: inherit;
    text-align: center;
    cursor: pointer;
    white-space: nowrap;
}
.close-button:hover {
    color: $black;
}

.switch-theme {
    color: $lime-3;
    cursor: pointer;
    text-decoration: underline;

    &:hover {
        color: black;
    }
}
</style>

<style lang="scss">
// When the message is visible it already provides the spacing below the fixed
// menu, so the page header on the same page only needs a small gap above it.
// Once the message is dismissed (v-if removes it from the DOM), this rule
// stops matching and the header gets its full top padding back, so it never
// slides under the menu.
.container-content:has(.switch-theme-message) .page-header {
    padding-top: 0.5rem;
}
</style>
